import React from 'react'
import { EntityDetailView } from '@/components/entity/EntityDetailView'

export function BrokerDetail() {
  return <EntityDetailView entityType="broker" />
}

